import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeButtonLabel: {
		id: 'software-backlog-panel.common.panel.header.close-button-label',
		defaultMessage: 'Close panel',
		description: 'Accessibility label for a button that closes the panel.',
	},
	epicCardDescription: {
		id: 'software-backlog-panel.common.panel.header.epic-card-description',
		defaultMessage: 'Whatever you select will be shown in the main content',
		description: 'aria-describedby text for epic card buttons.',
	},
});
